import { Inline, useCollapse } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useCollectionsImport } from 'hooks'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { CollectionsSelector } from 'ui'
import { CollapsibleRule } from '../CollapsibleRule'
import { SelectorComponentProps } from '../constants'
import { OperatorSelector } from '../OperatorSelector'

export function CollectionsScopeSelector(props: SelectorComponentProps) {
  const { name, form, open } = props

  const items: Item[] = useWatch({ form, name: `${name}.items` })

  const collapsibleState = useCollapse({ visible: open })

  const { importCollections, loading } = useCollectionsImport()

  return (
    <CollapsibleRule state={collapsibleState}>
      <CollapsibleRule.Header
        state={collapsibleState}
        onRemove={() => form.setValue(name, undefined)}
      >
        <CollapsibleRule.Title state={collapsibleState} count={items.length}>
          <CollectionsSelector.Header />
        </CollapsibleRule.Title>
      </CollapsibleRule.Header>
      <CollapsibleRule.Content
        state={collapsibleState}
        focusId={`${name}.items`}
      >
        <CollectionsSelector>
          <CollapsibleRule.Actions>
            <OperatorSelector name={`${name}.operator`} form={form} />
            <Inline>
              <CollectionsSelector.Download values={items} />
              <CollectionsSelector.Upload
                name={`${name}.items`}
                form={form}
                importer={importCollections}
                maxEntries={LIMITS.MAX_COLLECTIONS}
              />
            </Inline>
          </CollapsibleRule.Actions>
          <CollectionsSelector.Selector
            name={`${name}.items`}
            form={form}
            loading={loading}
          />
        </CollectionsSelector>
      </CollapsibleRule.Content>
    </CollapsibleRule>
  )
}
